import { render, staticRenderFns } from "./ModulesGallery.vue?vue&type=template&id=99022156"
import script from "./ModulesGallery.vue?vue&type=script&lang=js"
export * from "./ModulesGallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BasicImage: require('/var/www/vhosts/anothercodeproject.eu/jgast.anothercodeproject.eu/components/basic/BasicImage.vue').default})
